export default __webpack_public_path__ + "static/no-photo-42965531b3fb2704039b837cf7a2485b.png";